import createApiClient from "./api";

const api = createApiClient();

export const createSubscription = async (priceId, projectId = null) => {
  let url = `/subscriptions/create-subscription?price_id=${priceId}`;
  if (projectId) {
    url += `&project_id=${projectId}`;
  }
  const response = await api.post(url);
  return response.data;
};

export const createCheckoutSession = async ({ plan, projectId = null }) => {
  let url = `/subscriptions/create-checkout-session?plan=${plan}`;
  if (projectId) {
    url += `&project_id=${projectId}`;
  }
  const response = await api.post(url);
  return response.data;
};

export const cancelSubscription = async (projectId) => {
  const response = await api.delete(
    `/subscriptions/cancel-subscription?project_id=${projectId}`
  );
  return response.data;
};

export const requestCancelSubscription = async () => {
  const response = await api.post(`/subscriptions/cancel-subscription-request`);
  return response.data;
};